/**
 * Rumbo: el cerrojo de «solo ver» (puerta de planes). `PuertaPlan` (montada
 * una vez en la app) apunta aquí si la cuenta está en solo ver; cualquier
 * acción que escribe llama a `comprobarPlan()` antes de seguir: si no hay
 * plan, se abre la hoja «Tu periodo ha terminado» y la acción no sigue.
 */

const EVENTO = 'rumbo-periodo-terminado';

let soloVerAhora = false;

export function ponerSoloVer(valor: boolean) {
  soloVerAhora = valor;
}

/** ¿Se puede escribir? Si no, abre la hoja y devuelve false. */
export function comprobarPlan(): boolean {
  if (!soloVerAhora) {
    return true;
  }
  window.dispatchEvent(new Event(EVENTO));
  return false;
}

export function alPedirHoja(abrir: () => void): () => void {
  window.addEventListener(EVENTO, abrir);
  return () => window.removeEventListener(EVENTO, abrir);
}

const CLAVE_VISTA = 'rumbo-periodo-visto';

/** Día (AAAA-MM-DD, hora local) para enseñar la hoja una vez al día. */
export function hoyLocal(fecha = new Date()): string {
  const m = String(fecha.getMonth() + 1).padStart(2, '0');
  const d = String(fecha.getDate()).padStart(2, '0');
  return `${fecha.getFullYear()}-${m}-${d}`;
}

export function vistaHoy(hoy = hoyLocal()): boolean {
  try {
    return window.localStorage.getItem(CLAVE_VISTA) === hoy;
  } catch {
    return false;
  }
}

export function marcarVistaHoy(hoy = hoyLocal()) {
  try {
    window.localStorage.setItem(CLAVE_VISTA, hoy);
  } catch {
    // Sin almacenamiento, la hoja vuelve a salir al abrir: no pasa nada.
  }
}

/** Acciones de la brújula que cambian datos (en solo ver, abren la hoja). */
export const OPCIONES_QUE_ESCRIBEN: ReadonlySet<string> = new Set([
  'anadir-movimiento',
  'asignar',
  'mover',
  'nueva-regla',
  'editar-categorias',
  'fijar',
  'grupos-anuales',
  'seleccionar',
  'zarpar',
  'cerrar-travesia',
  'opciones-cuenta',
]);
